<template>
    <div class="share-btn btn-secondary text-sm gap-x-2 flex items-center border">
        <span class="text-[var(--medium-gray)]">Share</span>

        <a :href="`http://www.linkedin.com/sharing/share-offsite/?mini=true&url=${encodeURIComponent(location)}&title=${encodeURIComponent(title
            || '')}&summary=${encodeURIComponent(summary || '')}`" target="_blank" class="social-btn"
            title="Share to LinkedIn">
            <Icon name="mdi:linkedin" class="ml-1" />
        </a>
        <!-- <a :href="`http://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(location)}`" target="_blank"
            class="btn btn-sm btn-primary text-sm " title="Share to Facebook">
            <Icon name="mdi:facebook" class="text-md" />
        </a> -->
        <a :href="`http://www.twitter.com/share?url=${encodeURIComponent(location)}&text=${encodeURIComponent(title || '')}&summary=${encodeURIComponent(summary || '')}`"
            target="_blank" class="social-btn" title="Share to Twitter">
            <Icon name="mdi:twitter" class="ml-1" />
        </a>
        <a :href="`http://www.reddit.com/submit?url=${encodeURIComponent(location)}&title=${encodeURIComponent(title || '')}&summary=${encodeURIComponent(summary || '')}`"
            target="_blank" class="social-btn" title="Share to Reddit">
            <Icon name="mdi:reddit" class="ml-1" />
        </a>
        <!-- hackernews -->
        <a :href="`https://news.ycombinator.com/submitlink?u=${encodeURIComponent(location)}&t=${encodeURIComponent(title || '')}&summary=${encodeURIComponent(summary || '')}`"
            target="_blank" class="social-btn" title="Share to Hacker News">
            <Icon name="ion:logo-hackernews" class="ml-1" />
        </a>
    </div>
</template>

<script lang="ts">
export default {
    props: {
        title: String,
        summary: String
    },
    data() {
        return {
            location: useRoute().fullPath
        }
    }
    // methods: {

    //     submit() {
    //         console.log('submit');
    //         window.open(
    //             `mailto:hello@unified.to?subject=${this.sentiment === true ? 'Positive' : 'Negative'}%20Feedback&body=${encodeURIComponent(
    //                 'My feedback on ' + window.location.href + '\n\n' + this.feedback
    //             )}`
    //         );
    //         this.popup();
    //     },
    // },
};
</script>

<style scoped>
.share-btn {
    @apply hover:border-[var(--primary-blue)] border-[var(--medium-gray)] text-[var(--white)] text-xs px-2 py-1 rounded-md;
}

.social-btn {
    @apply text-white;
}

.social-btn:hover {
    @apply text-[var(--primary-blue)];
}
</style>